import { createStyles } from '@material-ui/core';
import { Colours } from './FieldsWidget.constants';

export const styles = (theme: any) => createStyles({
  paper: {
    width: '280px',
    float: 'right',
    padding: '15px',
    margin: '15px',
    display: 'flex',
    flexDirection: 'column'
  },
  unsetBackground: {
    backgroundColor: 'unset'
  },
  isInSummaryPanel: {
    padding: 10,
    margin: 10,
    borderRadius: 'unset',
    marginBottom: 0
  },
  table: {
    width: '100%',
    border: '1px white',
  },
  lastTable: {
    width: '100%',
    border: '1px white',
  },
  tableRow: {
    height: 'inherit',
  },
  propertyCell: {
    width: '75px',
    backgroundColor: '#eeeeee',
    border: '1px solid #fff',
    padding: '10px',
    fontSize: '10px',
    fontWeight: 'bold',
    textTransform: 'uppercase'
  },
  propertyCellMatchCase: {
    width: '75px',
    backgroundColor: '#eeeeee',
    border: '1px solid #fff',
    padding: '10px',
    fontSize: '10px',
    fontWeight: 'bold',
  },
  valueCell: {
    width: 'calc(100% - 75px)',
    backgroundColor: '#dddddd',
    border: '1px solid #fff',
    padding: '10px',
    fontSize: '15px',
    color: 'rgba(0, 0, 0, 0.87)',
  },
  lastValueCell: {
    width: 'calc(100% - 75px)',
    backgroundColor: '#bbbbbb',
    border: '1px solid #fff',
    padding: '10px',
    fontSize: '16px',
    color: 'rgba(0, 0, 0, 0.87)',
    fontWeight: 'bold',
  },
  preLoaderParent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '15px',
  },
  lastPreLoaderParent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  subPanelTitle: {
    color: '#000000',
    fontSize: '15px',
    marginBottom: '10px',
  },
  outer: {
    alignItems: 'center',
    display: 'flex'
  },
  numericOuter: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  numericSplitCellAction: {
    flex: '1',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    right: '10px'
  },
  hyperlinkedContent: {
    flex: '5',
    color: theme.palette?.hyperLink,
    textDecoration: 'underline',
    cursor: 'pointer'
  },
  link: {
    color: theme.palette?.hyperLink,
    textDecoration: 'underline',
    cursor: 'pointer'
  },
  splitCellAction: {
    flex: '1',
    display: 'flex',
    alignItems: 'center',
  },
  splitCellContent: {
    flex: '5',
    overflowWrap: 'anywhere'
  },
  value: {
    whiteSpace: 'pre-wrap',
    maxWidth: '10rem',
    display: 'inline-block',
  },
  actionIcon: {
    color: 'rgb(3, 1, 4)'
  }
});

export const fieldsWidgetStyles = (theme: any) => ({
  paper: {
    padding: '10px',
    margin: 0
  },
  paperContainer: {
    display: 'flex',
    flexWrap: 'wrap' as const,
    justifyContent: 'space-between'
  },
  row: {
    display: 'flex',
    flexWrap: 'wrap' as const
  },
  fieldCell: {
    flex: '1 1 25%',
    width: '100%',
    maxWidth: 'calc(25% - 2px)',
    margin: '0 2px 1px 0',
    boxSizing: 'border-box' as const,
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('lg')]: {
      flex: '1 1 33.3333%',
      maxWidth: 'calc(33.3333% - 2px)'
    },
    [theme.breakpoints.down('md')]: {
      flex: '1 1 50%',
      maxWidth: 'calc(50% - 2px)'
    },
    [theme.breakpoints.down('sm')]: {
      flex: '1 1 100%',
      maxWidth: 'calc(100% - 2px)'
    }
  },
  label: {
    'display': 'flex',
    'alignItems': 'center',
    'minWidth': 'calc(40% - 2px)',
    'maxWidth': 'calc(40% - 2px)',
    'backgroundColor': '#eeeeee',
    'borderRight': '1px solid #fff',
    'margin': 0,
    'height': '100%',
    'overflowWrap': 'anywhere' as const,
    '& > .MuiTypography-root': {
      fontSize: '10px',
      fontWeight: 'bold' as const,
      textTransform: 'uppercase' as const,
    }
  },
  value: {
    'minWidth': '60%',
    'maxWidth': '60%',
    'margin': 0,
    'backgroundColor': '#dddddd',
    'height': '100%',
    'display': 'flex',
    'alignItems': 'center',
    '& > .MuiTypography-root': {
      fontSize: '15px',
    }
  },
  cellContent: {
    padding: '10px',
    width: '100%',
  },
  iconLink: {
    marginLeft: 8
  },
  actionBtn: {
    color: '#000',
    textDecoration: 'underline !important'
  },
  landscape: {
    width: '100%'
  },
  portrait: {
    width: 'calc(100% - 20px)'
  },
  widgetTitle: {
    padding: '10px',
    backgroundColor: '#eeeeee',
    fontSize: '14px',
    fontWeight: 'bold' as any,
    lineHeight: '34px',
    textTransform: 'uppercase' as any,
    boxSizing: 'border-box' as const
  },
  hrefContainer: {
    overflowWrap: 'anywhere' as const,
    display: 'flex',
    alignItems: 'flex-start',
    columnGap: '4px',
  },
  hrefValue: {
    wordBreak: 'break-word' as const,
    color: theme.palette?.hyperLink,
    textdecoration: 'none',
  },
  valueComponentColor: {
    overflowWrap: 'anywhere' as any,
    width: '100%',
    height: '100%',
    borderRadius: '5px',
    padding: '8px 2px',
    display: 'flex',
    justifyContent: 'center',
    fontWeight: 'bold' as any,
    color: '#fff'
  },
  valueComponent: {
    overflowWrap: 'anywhere' as any,
    whiteSpace: 'pre-wrap' as any,
  },
  FieldButton: {
    'backgroundColor': Colours.Amber,
    'width': '100%',
    'textDecoration': 'underline',
    'fontWeight': 'bold' as const,
    'color': '#fff',
    '&:hover': {
      backgroundColor: Colours.Amber,
    }
  },
  fieldsContainer: {
    width: '100%',
  },
  fullWidthButton: {
    width: 'calc(100% - 1px)',
    maxWidth: '100%',
    textAlign: 'center' as const
  },
  valueContainer: {
    display: 'flex',
    flexDirection: 'column' as const
  },
  potraitContainer: {
    marginBottom: '1px'
  }
});
